<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">Transações Bancárias</h1>
        </v-flex>
        <v-layout row wrap class="transactions-filter" pt-4 px-3>
          <v-flex xs12 md3 lg2 px-1>
            <DefaultFilterDate ref="filterStartDate" @reload="this.reloadStartDate" kind="date" label="Data Inicial"/>
          </v-flex>
          <v-flex xs12 md3 lg2 px-1>
            <DefaultFilterDate ref="filterEndDate" @reload="this.reloadEndDate" kind="date" label="Data Final"/>
          </v-flex>
          <v-flex xs12 md3 lg2 px-1>
            <CompanySelect
            :model="filterCompanyId"
            label="Parceiro"
            @onIdSelected="this.companyIdSelected"
            @onCompanyList="this.companyListSelected"
            ref="filterCompanyId"
            />
          </v-flex>
          <v-flex xs12 md3 lg2 px-1>
            <CompanySelect
            :model="filterSubjectId"
            :label="i18n('Nº do Doc. Cliente')"
            search_mode="document_number_prefix"
            @onIdSelected="this.subjectIdSelected"
            @onCompanyList="this.subjectListSelected"
            ref="filterSubjectId"
          />
          </v-flex>
          <v-flex xs12 md3 lg2 px-1>
            <v-select
              box
              label="Moeda"
              v-model="filterCurrency"
              clearable
              @click:clear="filterCurrency = null"
              @change="filterCurrencyChanged()"
              :items="currencyFilterItems"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3 lg2 class="align-contents-right">
            <v-btn class="filter-btn" color="#27DABC" depressed dark @click="filter()">
              Consultar
              <ion-icon name="funnel-outline"></ion-icon>
            </v-btn>
            <v-btn class="reload-filter-btn" flat icon color="white" @click="resetFilter()">
              <ion-icon name="reload-outline" size="large"></ion-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 md8>
            <v-text-field
              :error="error"
              v-model="filterId"
              box
              append-icon="search"
              class="search-filter"
              placeholder="Pesquisar por ID"
            ></v-text-field>
          </v-flex>
          <v-layout row wrap align-center>
            <v-flex xs6 md6 pa-1>
              <v-switch
                v-model="filterUnmatched"
                label="Sem transação programada"
              ></v-switch>
            </v-flex>
            <v-flex xs6 md6>
              <v-switch
                v-model="filterRefunded"
                label="Apenas Reembolsadas"
              ></v-switch>
            </v-flex>
          </v-layout>
          <v-flex xs6 md1 pa-3>
            <v-icon large v-if="bankTransactionsConfig.loading">hourglass_bottom</v-icon>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <div class="mt-3" v-if="bankTransactionsLoaded == 'not_loaded'">Carregando transações...</div>
          <div class="mt-3" v-if="bankTransactionsLoaded == 'error'">Algo errado. Não foi possível carregar as transações.</div>
          <div class="mt-3" v-if="bankTransactionsLoaded == 'not_authorized'">Não foi possível carregar as transações. Você não foi autorizado.</div>
          <div class="mt-3" v-if="bankTransactionsLoaded == 'empty'">Não existem transações bancárias neste momento.</div>
          <transition name="fade">
            <bank-transaction-list class="mt-3" :config="bankTransactionsConfig" v-if="bankTransactionsLoaded == 'ok'" @loadMoreRecords="loadMoreRecords" />
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import BankTransactionList from "./BankTransactionList"
import DefaultFilterDate from "./components/filters/DefaultFilterDate"
import CompanySelect from "./components/filters/CompanySelect"
import { getAllCurrenciesSelect } from "./shared/Currencies";
import utils from "./shared/Utils"
import { BankTransactionService} from '@/shared/BankTransactionsService'

export default {
  name: 'AdminBankTransactionList',
  components: { layout: LeftBarLayout, 'bank-transaction-list': BankTransactionList, DefaultFilterDate, CompanySelect },
  data() {
    return {
      bankTransactionsConfig: {
        title: 'Transações Bancárias Recentes',
        records: [],
        loading: false
      },
      error: false,
      bankTransactionService: null,
      companies: [],
      filterId: null,
      filterStartDate: null,
      filterEndDate: null,
      resultsToFetch: 100,
      filterCurrency: null,
      filterCompanyId: null,
      filterSubjectId: null,
      filterRefunded: null,
      filterUnmatched: null,
      filterCompanyList: [],
      filterSubjectList: [],
      consolidateFilter: {
        filterId: null,
        filterStartDate: null,
        filterEndDate: null,
        filterCurrency: null,
        filterCompanyId: null,
        filterSubjectId: null,
        filterRefunded: null,
        filterUnmatched: null,
        filterCompanyList: [],
        filterSubjectList: [],
      },
      bankTransactionsLoaded: 'not_loaded',
      currencyFilterItems: getAllCurrenciesSelect(),
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    this.bankTransactionService = new BankTransactionService(this)
    this.loadBankTransactions()
  },
  methods: {
    companyIdSelected(id) {
      this.filterCompanyId = id
    },
    subjectIdSelected(id) {
      this.filterSubjectId = id
    },
    companyListSelected(companyList) {
      this.filterCompanyList = companyList
    },
    subjectListSelected(subjectList) {
      this.filterSubjectList = subjectList
    },
    filterCurrencyChanged() {
    },
    resetToConsolidateFilter() {
      this.filterStartDate = this.consolidateFilter.filterStartDate;
      this.$refs.filterStartDate.filterDate = this.consolidateFilter.filterStartDate;

      this.filterEndDate = this.consolidateFilter.filterEndDate;
      this.$refs.filterEndDate.filterDate = this.consolidateFilter.filterEndDate;

      this.filterCompanyId = this.consolidateFilter.filterCompanyId;
      this.filterCompanyList = [...this.consolidateFilter.filterCompanyList];
      this.$refs.filterCompanyId.entries = [...this.consolidateFilter.filterCompanyList];
      this.$refs.filterCompanyId.search = '';
      this.$refs.filterCompanyId.selectedCompanyId = this.consolidateFilter.filterCompanyId;

      this.filterSubjectId = this.consolidateFilter.filterSubjectId;
      this.filterSubjectList = [...this.consolidateFilter.filterSubjectList];
      this.$refs.filterSubjectId.entries = [...this.consolidateFilter.filterSubjectList];
      this.$refs.filterSubjectId.search = '';
      this.$refs.filterSubjectId.selectedCompanyId = this.consolidateFilter.filterSubjectId;

      this.filterCurrency = this.consolidateFilter.filterCurrency;
      this.filterId = this.consolidateFilter.filterId;
      this.filterUnmatched = this.consolidateFilter.filterUnmatched;
      this.filterRefunded = this.consolidateFilter.filterRefunded;
    },
    filter() {
      this.consolidateFilter = {
        filterStartDate: this.filterStartDate,
        filterEndDate: this.filterEndDate,
        filterCompanyId: this.filterCompanyId,
        filterCompanyList: [...this.filterCompanyList],
        filterSubjectId: this.filterSubjectId,
        filterSubjectList: [...this.filterSubjectList],
        filterCurrency: this.filterCurrency,
        filterId: this.filterId,
        filterUnmatched: this.filterUnmatched,
        filterRefunded: this.filterRefunded
      };

      if (this.consolidateFilter.filterId != null && this.consolidateFilter.filterId.trim() === "") {
        this.consolidateFilter.filterId = null
      }

      this.reloadRecords()
    },
    reloadRecords() {
      if (this.bankTransactionsConfig.loading) {
        this.bankTransactionsConfig.loading = true
      } else {
        this.bankTransactionsConfig.loading = false
        this.resultsToFetch = 100
        this.bankTransactionsConfig.records = []
        this.bankTransactionsLoaded = 'not_loaded'
        this.loadBankTransactions()
      }
    },
    async resetFilter() {
      this.companies = []
      this.resultsToFetch = 100

      this.bankTransactionsLoaded = 'not_loaded'
      this.error = false

      this.filterStartDate = null
      this.$refs.filterStartDate.filterDate = null

      this.filterEndDate = null
      this.$refs.filterEndDate.filterDate = null

      this.filterCompanyId = null
      this.$refs.filterCompanyId.entries = [];
      this.$refs.filterCompanyId.search = ''
      this.$refs.filterCompanyId.selectedCompanyId = null

      this.filterSubjectId = null
      this.$refs.filterSubjectId.entries = [];
      this.$refs.filterSubjectId.search = ''
      this.$refs.filterSubjectId.selectedCompanyId = null

      this.filterId = null
      this.filterUnmatched = null
      this.filterRefunded = null

      this.consolidateFilter = {
        filterId: null,
        filterStartDate: null,
        filterEndDate: null,
        filterCurrency: null,
        filterCompanyId: null,
        filterSubjectId: null,
        filterRefunded: null,
        filterCompanyList: [],
        filterSubjectList: [],
      }

      this.reloadRecords()
    },
    reloadStartDate(startDate) {
      this.filterStartDate = startDate
    },
    reloadEndDate(endDate) {
      this.filterEndDate = endDate
    },
    loadMoreRecords([_, amount]) {
      this.resultsToFetch += amount
      this.loadBankTransactions()
    },
    loadMoreTransactionsCheck(currentLoadedBankTransactions, newBankTransactions) {
      const LIMIT_PER_PAGE = 100

      if(this.resultsToFetch <= LIMIT_PER_PAGE) {
        return false
      }

      if(newBankTransactions < LIMIT_PER_PAGE) {
        return false
      }

      if(currentLoadedBankTransactions + newBankTransactions >= this.resultsToFetch) {
        return false
      }

      return true
    },
    getBankTransactionLastId(bankTransaction) {
      if(bankTransaction.length === 0) {
        return null
      }

      return bankTransaction[bankTransaction.length - 1].id
    },
    async loadBankTransactions() {
      try {

        if (this.bankTransactionsConfig.loading) return

        this.resetToConsolidateFilter();
        const fromDate = utils.filterDateFrom(this.filterStartDate, false)
        const toDate = utils.filterDateTo(this.filterEndDate, false)

        const props = {
          fromDate,
          toDate,
          filterUnmatched: this.filterUnmatched,
          filterRefunded: this.filterRefunded,
          filterCompanyId: this.filterCompanyId,
          filterSubjectId: this.filterSubjectId,
          filterCurrency: this.filterCurrency,
          filterId: typeof this.filterId === 'string' ? this.filterId.trim() : this.filterId
        }

        this.bankTransactionsConfig.loading = true
        let loadMoreRecords = true

        while(loadMoreRecords) {
          props.lastId = this.getBankTransactionLastId(this.bankTransactionsConfig.records)
          const currentLoadedBankTransactions = this.bankTransactionsConfig.records.length
          const {bankTransactions, companies} = await this.bankTransactionService.fetchBankTransactions(this.companies, props)
          this.bankTransactionsConfig.loading = false
          this.bankTransactionsLoaded = 'ok'
          this.bankTransactionsConfig.records = this.bankTransactionsConfig.records.concat(bankTransactions)
          this.companies = companies

          loadMoreRecords = this.loadMoreTransactionsCheck(currentLoadedBankTransactions, bankTransactions.length)
        }
      } catch(e) {
        this.bankTransactionsConfig.loading = false

        if(e.message === "Unauthorized") {
          this.bankTransactionsLoaded = 'not_authorized'
        } else {
          this.bankTransactionsLoaded = 'error'
        }
      }
    },
    i18n(str) {
      return this.$root.l(str)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/AdminBankTransactionList.vue